import React, { useMemo } from 'react';
import cn from 'classnames';
import { toJsDateTime, toFormattedDateFromJsDate, DATE_FORMAT } from 'utils/date';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { Pane, CalendarIcon } from 'evergreen-ui';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './styles.module.scss';


const DatePickerComponent = ({ value, onDateChange, placeholder, disabled, inputClassName }) => {
  const jsDateValue = useMemo(() => 
    !value 
      ? null 
      : typeof value === 'string' 
        ? toJsDateTime(value) 
        : value
  , [value]);

  const handleDateChange = (jsDate) => {
    const isoDateString = toFormattedDateFromJsDate(jsDate, DATE_FORMAT.ISO);
    onDateChange(isoDateString);
  };

  return (
    <Pane className={styles.datepickerContainer}>
      <DatePicker
        selected={jsDateValue}
        onChange={handleDateChange}
        className={cn([styles.input, inputClassName])}
        wrapperClassName={styles.datepickerInputWrapper}
        placeholderText={placeholder}
        disabled={disabled}
        icon={<CalendarIcon color="var(--gray-600)" size={12} />}
        showIcon
        toggleCalendarOnIconClick
        disabledKeyboardNavigation
      />
    </Pane>
  );
};

DatePickerComponent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  onDateChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  inputClassName: PropTypes.string,
};

DatePickerComponent.defaultProps = {
  value: null,
  placeholder: 'MM/DD/YYYY',
  disabled: false,
  inputClassName: null,
};

export default React.memo(DatePickerComponent);
